import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IGetSiteSAMLAuthSettingForEmbeddedViewsResult extends IResult {
    authenticationSettingForEmbeddedViz?: string;
}

export class GetSiteSAMLAuthSettingForEmbeddedViewsRequest extends Request<{}, IGetSiteSAMLAuthSettingForEmbeddedViewsResult> {
  constructor() {
    super('getSiteSAMLAuthSettingForEmbeddedViews', null);
  }
}
